import React, { useEffect, useState, Fragment } from "react";
import styles from "Components/Topology/topology.module.scss";
import { Form, Select, Button, Row, Col, Input, Divider, Tooltip, FormInstance, InputNumber } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  IPV4Verify,
  IPV6DNSVerify,
  IPV6Verify,
  MacVerify,
  MaskVerify,
  PrefixLenVerify,
} from "../../../../Utility/RegExp";
import { useAppSelector, useAppDispatch } from "store/hook";
import {
  setStaticIPCount,
  setIPv4Disabled,
  setIPv4MaskDisabled,
  setIPv6DnsServer2Disabled,
} from "../../store/topologySlice";
import { BsFileEarmarkBreak } from "react-icons/bs";

const { Option } = Select;

interface LANProps {
  SubmitConfigonFinish: (arg: any) => void;
  form: FormInstance<any>;
}

const BulkConfigFLan = React.memo(({ SubmitConfigonFinish, form }: LANProps) => {
  const {
    formData,
    deviceNum,
    importSource,
    staticIPCount,
    IPv4Disabled,
    IPv4MaskDisabled,
    IPv6DnsServer2Disabled,
    selectedModel,
  } = useAppSelector((state) => state.topology);
  const disp = useAppDispatch();
  const [LANIPV6Static, setLANIPV6Static] = useState("");
  useEffect(() => {
    // console.log(form.getFieldValue('StaticIP'))
    const staticIPlength = form.getFieldValue("StaticIP")?.length;
    disp(setStaticIPCount(staticIPlength));
  }, [form.getFieldValue("StaticIP")]);

  useEffect(() => {
    disp(setIPv4Disabled(false));
    disp(setIPv4MaskDisabled(false));

    if (importSource === "NewConfig") {
      return;
    }

    const fields: any = {
      // IPv4
      LAN_ipv4_address: formData?.lan?.ipv4?.address,
      StaticIP: formData?.lan?.ipv4?.dhcp?.pool?.[0]?.fixed_ip,
      LAN_ipv4_netmask: formData?.lan?.ipv4?.netmask,
      LAN_ipv4_dhcpmode: formData?.lan?.ipv4?.dhcp?.mode || "off",
      LAN_ipv4_dhcp_start: formData?.lan?.ipv4?.dhcp?.pool[0].start,
      LAN_ipv4_dhcp_end: formData?.lan?.ipv4?.dhcp?.pool[0].end,
      ipv6_DHCP_address_assign: formData?.ipv6?.dhcp?.assigment || "stateful",
    };
    if (selectedModel === "M335-W6") {
      setLANIPV6Static(formData?.ipv6?.type || "delegate-prefix-from-wan");
      disp(setIPv6DnsServer2Disabled(false));

      fields.LAN_ipv6_type = formData?.ipv6?.type || "delegate-prefix-from-wan";
      // Internet - WAN Ethernet
      fields.ipv6_WAN_static_adress = formData?.ipv6?.static?.wan_ethernet?.address;
      fields.ipv6_WAN_prefix_length = formData?.ipv6?.static?.wan_ethernet?.prefix;
      fields.ipv6_WAN_default_gateway = formData?.ipv6?.static?.wan_ethernet?.gateway;

      // LAN
      fields.ipv6_LAN_static_adress = formData?.ipv6?.static?.lan?.address;
      fields.ipv6_LAN_prefix_length = formData?.ipv6?.static?.lan?.prefix;

      // DNS
      fields.ipv6_DNS_server_1 = formData?.ipv6?.static?.dns?.[0];
      fields.ipv6_DNS_server_2 = formData?.ipv6?.static?.dns?.[1];
    }
    form.setFieldsValue(fields);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <Form onFinish={SubmitConfigonFinish} form={form} scrollToFirstError layout="vertical">
      <div className="formwrap">
        <Row gutter={24} justify="space-around">
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
            <h2>IPv4</h2>
            <Divider className={styles.divider} />
            <Row gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_address"}
                  label={<span style={IPv4Disabled ? { textDecoration: " line-through" } : {}}>IP Address</span>}
                  rules={[
                    {
                      required: IPv4Disabled ? false : true,
                      message: "required!",
                    },
                    IPV4Verify,
                  ]}
                >
                  <Input
                    disabled={IPv4Disabled}
                    placeholder={"192.0.0.0"}
                    maxLength={30}
                    addonAfter={
                      <Tooltip title="Exclude this field">
                        <BsFileEarmarkBreak onClick={() => disp(setIPv4Disabled(!IPv4Disabled))} />
                      </Tooltip>
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_netmask"}
                  label={<span style={IPv4MaskDisabled ? { textDecoration: " line-through" } : {}}>IP Mask</span>}
                  rules={[
                    {
                      required: IPv4MaskDisabled ? false : true,
                      message: "required!",
                    },
                    MaskVerify,
                  ]}
                >
                  {/* setIPv4MaskDisabled */}
                  <Input
                    disabled={IPv4MaskDisabled}
                    placeholder="255.255.255.0"
                    maxLength={30}
                    addonAfter={
                      <Tooltip title="Exclude this field">
                        <BsFileEarmarkBreak onClick={() => disp(setIPv4MaskDisabled(!IPv4MaskDisabled))} />
                      </Tooltip>
                    }
                  />
                </Form.Item>
              </Col>
              <h3>DHCP Server Configuration</h3>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_dhcpmode"}
                  label="DHCP Server"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                  ]}
                  initialValue={"off"}
                  tooltip={"Enable to make router can lease IP address to DHCP clients which connect to LAN."}
                >
                  <Select placeholder="ON/OFF">
                    <Option key={0} value={"on"}>
                      ON
                    </Option>
                    <Option key={1} value={"off"}>
                      OFF
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_dhcp_start"}
                  label="IP Address Pool (From)"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                    IPV4Verify,
                  ]}
                >
                  <Input placeholder="192.0.0.0" maxLength={30} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  name={"LAN_ipv4_dhcp_end"}
                  label="IP Address Pool (To)"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                    IPV4Verify,
                  ]}
                >
                  <Input placeholder="192.0.0.0" maxLength={30} />
                </Form.Item>
              </Col>

              {deviceNum.length <= 1 && (
                <Form.List name="StaticIP">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field) => (
                        <Row gutter={24} key={field.key} style={{ marginLeft: "0px", width: "100%" }}>
                          <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                            <Form.Item
                              {...field}
                              name={[field.name, "enabled"]}
                              // fieldKey={[field.fieldKey, "enabled"]}
                              label="Statistic"
                              style={{ minWidth: "100px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "required!",
                                },
                              ]}
                            >
                              <Select placeholder={"ON/OFF"}>
                                {/* @ts-ignore */}
                                <Option key={0} value={true}>
                                  ON
                                </Option>
                                {/* @ts-ignore */}
                                <Option key={1} value={false}>
                                  OFF
                                </Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                            <Form.Item
                              {...field}
                              name={[field.name, "mac"]}
                              // fieldKey={[field.fieldKey, "mac"]}
                              label="MAC"
                              rules={[MacVerify]}
                            >
                              <Input placeholder="aa:bb:cc:dd:ee:ff" maxLength={30} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={7}>
                            <Form.Item
                              {...field}
                              name={[field.name, "ip"]}
                              // fieldKey={[field.fieldKey, "ip"]}
                              label="IP"
                              rules={[IPV4Verify]}
                            >
                              <Input placeholder="0.0.0.0" maxLength={30} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={2} className="mb-2">
                            <Button
                              danger
                              ghost
                              block
                              type="text"
                              icon={<MinusCircleOutlined />}
                              onClick={() => {
                                disp(setStaticIPCount(form.getFieldValue("StaticIP")?.length));
                                remove(field.name);
                              }}
                            ></Button>
                          </Col>
                        </Row>
                      ))}
                      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item>
                          <Button
                            type="dashed"
                            disabled={deviceNum.length > 1 || staticIPCount === 16}
                            onClick={() => {
                              disp(setStaticIPCount(form.getFieldValue("StaticIP")?.length));
                              add();
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Add Static IP
                          </Button>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Form.List>
              )}
            </Row>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }}>
            <h2>IPv6</h2>
            <Divider className={styles.divider} />
            {selectedModel === "M335-W6" && (
              <>
                <Form.Item
                  name={"LAN_ipv6_type"}
                  label="Type"
                  rules={[
                    {
                      required: true,
                      message: "required!",
                    },
                  ]}
                  initialValue={"delegate-prefix-from-wan"}
                  tooltip={
                    <Fragment>
                      {" "}
                      <p>
                        Delegate Prefix from WAN: Automatically obtain an IPv6 network prefix from the service provider
                        or an uplink router.
                      </p>{" "}
                      <p>Static: Configure a fixed IPv6 address for the cellular router.</p>{" "}
                    </Fragment>
                  }
                >
                  <Select
                    onChange={(value: string) => {
                      setLANIPV6Static(value);
                    }}
                    placeholder="Delegate/Static"
                  >
                    <Option key={0} value={"delegate-prefix-from-wan"}>
                      Delegate Prefix from WAN
                    </Option>
                    <Option key={1} value={"static"}>
                      Static
                    </Option>
                  </Select>
                </Form.Item>
                {LANIPV6Static === "static" && (
                  <>
                    <h3>WAN Ethernet Configuration</h3>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                          name={"ipv6_WAN_static_adress"}
                          label="Static Address"
                          rules={[
                            {
                              required: LANIPV6Static === "static",
                              message: "required!",
                            },
                            IPV6Verify,
                          ]}
                        >
                          <Input
                            disabled={LANIPV6Static !== "static"}
                            placeholder="2001:288:3600:10::1"
                            maxLength={50}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                          name={"ipv6_WAN_prefix_length"}
                          label="Prefix Length"
                          rules={[
                            {
                              required: LANIPV6Static === "static",
                              message: "required!",
                            },
                          ]}
                        >
                          <InputNumber
                            disabled={LANIPV6Static !== "static"}
                            style={{ width: "100%" }}
                            placeholder="64 (Range: 0–128)"
                            min={0}
                            max={128}
                            step={1}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                          name={"ipv6_WAN_default_gateway"}
                          label="Default Gateway"
                          rules={[
                            {
                              required: LANIPV6Static === "static",
                              message: "required!",
                            },
                            IPV6Verify,
                          ]}
                        >
                          <Input
                            disabled={LANIPV6Static !== "static"}
                            placeholder="2001:288:3600:10::2"
                            maxLength={50}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <h3>LAN Configuration</h3>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                          name={"ipv6_LAN_static_adress"}
                          label="Static Address"
                          rules={[
                            {
                              required: LANIPV6Static === "static",
                              message: "required!",
                            },
                            IPV6Verify,
                          ]}
                        >
                          <Input
                            disabled={LANIPV6Static !== "static"}
                            placeholder="2001:288:3600:7::1"
                            maxLength={50}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                          name={"ipv6_LAN_prefix_length"}
                          label="Prefix Length"
                          rules={[
                            {
                              required: LANIPV6Static === "static",
                              message: "required!",
                            },
                          ]}
                        >
                          <InputNumber
                            disabled={LANIPV6Static !== "static"}
                            style={{ width: "100%" }}
                            placeholder="64 (Range: 0–128)"
                            min={0}
                            max={128}
                            step={1}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <h3>DNS Configuration</h3>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                          name={"ipv6_DNS_server_1"}
                          label="IPv6 DNS Server #1"
                          rules={[
                            {
                              required: LANIPV6Static === "static",
                              message: "required!",
                            },
                            IPV6Verify,
                          ]}
                        >
                          <Input
                            disabled={LANIPV6Static !== "static"}
                            placeholder="2001:4860:4860::8888"
                            maxLength={50}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <Form.Item
                          name={"ipv6_DNS_server_2"}
                          label={
                            <span style={IPv6DnsServer2Disabled ? { textDecoration: " line-through" } : {}}>
                              IPv6 DNS Server #2
                            </span>
                          }
                          rules={[IPV6Verify]}
                        >
                          <Input
                            disabled={LANIPV6Static !== "static" || IPv6DnsServer2Disabled}
                            placeholder="2001:4860:4860::8844"
                            maxLength={40}
                            addonAfter={
                              <Tooltip title="Exclude this field">
                                <BsFileEarmarkBreak
                                  onClick={() => disp(setIPv6DnsServer2Disabled(!IPv6DnsServer2Disabled))}
                                />
                              </Tooltip>
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            <h3>DHCP Server Configuration</h3>
            <Form.Item
              name={"ipv6_DHCP_address_assign"}
              label="Address Assign"
              rules={[
                {
                  required: true,
                  message: "required!",
                },
              ]}
              initialValue={"stateful"}
              tooltip={
                <Fragment>
                  {" "}
                  <p>
                    Stateless: The cellular router uses IPv6 stateless auto configuration. RADVD (Router Advertisement
                    Daemon) is enabled to have the cellular router send IPv6 prefix information in router advertisements
                    periodically and in response to router solicitations.
                  </p>{" "}
                  <p>
                    Stateful: The cellular router uses IPv6 stateful auto configuration. The LAN IPv6 clients can obtain
                    IPv6 addresses through DHCPv6.
                  </p>{" "}
                </Fragment>
              }
            >
              <Select placeholder={"Stateful/Stateless"}>
                <Option key={0} value={"stateful"}>
                  Stateful
                </Option>
                <Option key={1} value={"stateless"}>
                  Stateless
                </Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
});

export default BulkConfigFLan;

////////////////////////////////////////////////////////

export const assemble = (values: any, IPv4MaskDisabled: boolean, IPv4Disabled: boolean) => {
  let LanJSON: any = {
    ipv4: {
      dhcp: {
        mode: values.LAN_ipv4_dhcpmode,
        pool: [
          {
            start: values.LAN_ipv4_dhcp_start,
            end: values.LAN_ipv4_dhcp_end,
            fixed_ip: values.StaticIP || [],
          },
        ],
      },
    },
  };

  if (!IPv4Disabled) {
    LanJSON.ipv4.address = values.LAN_ipv4_address;
  }

  if (!IPv4MaskDisabled) {
    LanJSON.ipv4.netmask = values.LAN_ipv4_netmask;
  }

  return LanJSON;
};

export const assemble_ipv6 = (values: any, IPv6DnsServer2Disabled?: boolean) => {
  const model = values.model || "";
  if (model === "M335-W6") {
    let Ipv6JSON: any = {
      type: values.LAN_ipv6_type,

      dhcp: {
        assigment: values.ipv6_DHCP_address_assign,
      },
    };
    if (values.LAN_ipv6_type === "static") {
      Ipv6JSON.static = Ipv6JSON.static || {}; // 確保 static 存在
      Ipv6JSON.static.wan_ethernet = {
        address: values.ipv6_WAN_static_adress,
        gateway: values.ipv6_WAN_default_gateway,
        prefix: parseInt(values.ipv6_WAN_prefix_length),
      };
      Ipv6JSON.static.lan = {
        address: values.ipv6_LAN_static_adress,
        prefix: parseInt(values.ipv6_LAN_prefix_length),
      };
      Ipv6JSON.static.dns = IPv6DnsServer2Disabled
        ? [values.ipv6_DNS_server_1]
        : [values.ipv6_DNS_server_1, values.ipv6_DNS_server_2 ?? ""];
    }
    return Ipv6JSON;
  } else {
    let Ipv6JSON: any = {
      dhcp: {
        assigment: values.ipv6_DHCP_address_assign,
      },
    };

    return Ipv6JSON;
  }
};
